import { $, $$ } from '@utils';

function init() {
  if (!$('form')) return;

  addEventListeners();
}

function addEventListeners() {
  $$('input[type="number"]').forEach((input) => {
    input.addEventListener('keydown', restrictFormatOnInputTypeNumber);
  });
}

/**
 *
 * @param {*} event
 * Function to avoid writing letters on input type number (in firefox you can write letters even the input is type number)
 * If step="any", we can write , or .
 */
function restrictFormatOnInputTypeNumber(event) {
  const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];
  const isStepAny = this.getAttribute('step') === 'any';
  const isAllowedKey = allowedKeys.includes(event.key) || !isNaN(event.key);

  if (isStepAny ? !(isAllowedKey || event.key === ',' || event.key === '.') : !isAllowedKey) {
    event.preventDefault();
  }
}

export default { init };
